import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import type { ExtractInjectionAPI, PMPluginFactoryParams } from '@atlaskit/editor-common/types';

import type { AIPlugin } from '../../aiPluginType';

import {
	createInitialState,
	createPluginState,
	getPluginState,
} from './in-editor-streaming-plugin-factory';
import { inEditorStreamingPluginKey } from './in-editor-streaming-plugin-key';

export const createInEditorStreamingPlugin = (options: {
	dispatch: PMPluginFactoryParams['dispatch'];
	api: ExtractInjectionAPI<AIPlugin> | undefined;
}): SafePlugin => {
	const { dispatch } = options;

	return new SafePlugin({
		key: inEditorStreamingPluginKey,
		state: createPluginState(dispatch, createInitialState()),
		props: {
			decorations: (editorState) => {
				const pluginState = getPluginState(editorState);
				return pluginState.decorationSet;
			},
		},
	});
};
